import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useCommunityqContentTypesStore = defineStore('communityqContentTypes', {
  state: () => ({
    contentTypes: {}
  }),

  actions: {
    async fetch(publicationId) {
      return httpClient.get(`/api/internal/publications/${publicationId}/community_q/content_types`)
        .then(response => {
          this.contentTypes = response.data.content_types
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    }
  }
})
